import { useCallback, useState } from "react";

/**
 * Ref-counted boolean flag, used for the shell chrome-visibility overrides
 * (`isChromeHidden`, `isBottomNavHidden`, `isHideChromeOnScrollDisabled`).
 *
 * Returns the same `[value, setValue]` shape as `useState<boolean>` so call
 * sites don't need to change.
 */
export const useRefCountedFlag = (): readonly [
  boolean,
  (active: boolean) => void,
] => {
  const [count, setCount] = useState(0);
  const setActive = useCallback((active: boolean) => {
    setCount(current => Math.max(0, current + (active ? 1 : -1)));
  }, []);
  return [count > 0, setActive] as const;
};
